import { ASSESSMENTS_ERROR, CREATE_ASSESSMENT, CREATE_ASSESSMENT_RECORD, CREATING_ASSESSMENT, CREATING_ASSESSMENT_RECORD, DELETE_ASSESSMENT_RECORD, DELETING_ASSESSMENT_RECORD, GET_ASSESSMENT_RECORDS, GET_ASSESSMENTS, GETTING_ASSESSMENT_RECORDS, GETTING_ASSESSMENTS, UPDATE_ASSESSMENT, UPDATE_ASSESSMENT_RECORD, UPDATING_ASSESSMENT, UPDATING_ASSESSMENT_RECORD } from "../types"

const initialState = {
    assessments: [],
    fetchingAssessments: true,
    updatingAssessment: false,
    updatedAssessment: null,
    creatingAssessment: false,
    createdAssessment: null,
    assessmentRecords: [],
    loadingAssessmentRecords: true,
    creatingAssessmentRecord: false,
    createdAssessmentRecord: null,
    updatingAssessmentRecord: false,
    updatedAssessmentRecord: null,
    deletingAssessmentRecord: false,
    deletedAssessmentRecord: null,
    assessmentsError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case CREATING_ASSESSMENT:
        return {
            ...state,
            creatingAssessment: action.payload
        }
        case CREATE_ASSESSMENT:
        return {
            ...state,
            creatingAssessment: false,
            createdAssessment: action.payload
        }
        case UPDATING_ASSESSMENT: 
        return {
            ...state,
            updatingAssessment: action.payload
        }
        case UPDATE_ASSESSMENT:
        return {
            ...state,
            updatingAssessment: false,
            updatedAssessment: action.payload
        }
        case GETTING_ASSESSMENTS: 
        return {
            ...state,
            fetchingAssessments: action.payload
        }
        case GET_ASSESSMENTS:
        return {
            ...state,
            fetchingAssessments: false,
            assessments: action.payload
        }
        case GETTING_ASSESSMENT_RECORDS:
        return {
            ...state,
            loadingAssessmentRecords :action.payload,
        }
        case GET_ASSESSMENT_RECORDS:
        return{
            ...state,
            loadingAssessmentRecords:false,
            assessmentsError:  null,
            assessmentRecords: action.payload,
        }
        case CREATING_ASSESSMENT_RECORD:
        return {
            ...state,
            creatingAssessmentRecord :action.payload,
        }
        case CREATE_ASSESSMENT_RECORD:
        return{
            ...state,
            creatingAssessmentRecord:false,
            assessmentsError:  null,
            createdAssessmentRecord: action.payload,
        }
        case UPDATING_ASSESSMENT_RECORD:
        return {
            ...state,
            updatingAssessmentRecord :action.payload,
        }
        case UPDATE_ASSESSMENT_RECORD:
        return{
            ...state,
            updatingAssessmentRecord:false,
            assessmentsError:  null,
            updatedAssessmentRecord: action.payload,
        }
        case DELETING_ASSESSMENT_RECORD:
        return {
            ...state,
            deletingAssessmentRecord :action.payload,
        }
        case DELETE_ASSESSMENT_RECORD:
        return{
            ...state,
            deletingAssessmentRecord:false,
            assessmentsError:  null,
            deletedAssessmentRecord: action.payload,
        }
        case ASSESSMENTS_ERROR:
        return{
            ...state,
            loadingAssessmentRecords:false,
            assessmentsError: action.payload,
            creatingAssessmentRecord: false,
            updatingAssessmentRecord: false,
            deletingAssessmentRecord: false,
            updatingAssessment: false,
            creatingAssessment: false,
            fetchingAssessments: false

        }
        default: return state
    }

}